import React, { useEffect, useRef, useState, useMemo } from 'react';
import axios from 'axios';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { balbrigganCoords } from '../../constants';
import { decToHex } from 'hex2dec';
import { DragEndEvent, LatLngBounds, LeafletMouseEvent, Map } from 'leaflet';
import { API } from 'aws-amplify';
import { connect, useDispatch, useSelector } from 'react-redux';
import { newNotification } from 'actions/uiActions';
import { ORDER_RECEIVED } from '../../actions/actionTypes';
import CloseIcon from '@mui/icons-material/Close';
import {
  CircularProgress
} from '@mui/material';

import {
  orderStatuses,
  PAST_READY_STATUS_ARRAY
} from '../../constants/orderConstants';
import { latLngBounds } from 'leaflet';
import {
  selectFilteredOrders,
  selectLandingZones,
  selectSelectedCellId
} from '../../selectors/ordersSelector';

 
import {
  finaliseRouteThunk,
  getLandingZonesInCell,
  setRouteConfirmationOrder
} from 'actions/orderActions';
import { upsertOrderCardById } from 'actions/orderActions';
import { selectActivePads } from 'selectors/liveAircraftSelectors';
import { selectInactivePads } from 'selectors/liveAircraftSelectors';
import { selectObstacles } from 'reducers/obstaclesReducer';
import { getObstacles } from 'actions/obstacleActions';
import { distToSegment } from 'views/RoutePlanner/util';
import { RouteConfirmationMap } from './components/RouteConfirmationMap';
import { getDistanceBetweenPoints } from '../../utils/parsingUtils';
import { logToDatadog } from '../../services/datadog';
import { getLandingPads } from '../../actions/liveAircraftActions';
import { getLatestJwtToken } from '../../services/amplify-auth';
import RouteConfirmationGraph from './components/RouteConfirmationGraph';
import { LandingPad, PlaceContext } from '@m4a3/api-client';
import { Switch } from '@headlessui/react';
import { selectPointOfSales } from 'selectors/adminSelector';
import { validateDropLocation } from '../../actions/adminActions';
import { renderOrderKm } from '../../utils/orderUtils';
import { 
  isDropPointCreationDisabled, 
  getDropPointRestrictionMessage,
  getCellNameForRestrictions,
  isVerifiedRiskOnlyCell 
} from '../../utils/cellDropPointUtils';
import { orderfulApi } from 'services/api-instances';
import { DropPointRow } from 'components/PlaceContextDropPoints/PlaceContextDropPoints';

const CODE_DISPLAY_HEIGHT = Math.round(window.innerHeight * 0.7);

const createFeatureCollectionWithCoords = (routeCoords, properties) => {
  // If routeCoords is in new structure (RoutePoint), extract just coordinates
  const coords = routeCoords[0]?.coordinates ? 
    routeCoords.map(point => point.coordinates) : routeCoords;

  return {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: properties,
        geometry: {
          type: 'LineString',
          coordinates: coords
        }
      }
    ]
  };
};

export type DropPoint = {
  id: number;
  latitude: number;
  longitude: number;
  isEvaluated: boolean;
  isLowRisk: boolean;
}

export enum RoutePointType {
  START_POINT_BASE = 'startpoint',
  WAYPOINT = 'waypoint',
  CUSTOMER_DROP_LOCATION = 'drop',
  END_POINT_BASE = 'endpoint'
}

export interface RoutePoint {
  coordinates: [number, number];  // [latitude, longitude]
  type: RoutePointType;  // 'startpoint' BASE | 'point' WAYPOINT | 'drop' CUSTOMER DROP | 'endpoint' BASE
  index: number; // Position in the route
}

const RouteConfirmation = ({ order, handleClose, notify, geofences }) => {

  const dispatch = useDispatch();

  const isMounted = useRef(true);
  const mapRef = useRef<Map>();
  const missionIdRef = useRef();
  const routeCoordsRef = useRef<RoutePoint[]>([]); //Use updateRouteCoordinates not routeCoordsRef.current = 
  const selectedCoordsRef = useRef([]); //Use updateSelectedRouteCoords not routeCoordsRef.current = 

  const [orderToUse, setOrderToUse] = useState(order);
  const [routeCoords, setRouteCoords] = useState<RoutePoint[]>([]); //Use updateRouteCoordinates not setRouteCoords
  const [suggestedRouteCoords, setSuggestedRouteCoords] = useState<[number, number][]>([]); //The suggested or recommended route, routeCoords represents the current and actual route the drone will take. 
  const [selectedCoords, setSelectedCoords] = useState([]); //Use updateSelectedRouteCoords not setSelectedCoords
  const [geoTunnel, setGeoTunnel] = useState();
  const [addressInfo, setAddressInfo] = useState<PlaceContext>();
  const [missionRoutes, setMissionRoutes] = useState();
  const [missionRoutesLen, setMissionRoutesLen] = useState(0);
  const [updating, setUpdating] = useState(false);
  const [reserving, setReserving] = useState(false);
  const [hasUpdatedRoute, setHasUpdatedRoute] = useState(false);
  const [outerMapBounds, setOuterMapBounds] = useState();
  const [selectedOriginPadId, setSelectedOriginPadId] = useState<number | undefined>(order.originLandingPadId);
  const [selectedDestinationPadId, setSelectedDestinationPadId] = useState<number | undefined>(order.destinationLandingPadId);
  const [proposedNewDropPoint, setProposedNewDropPoint] = useState<DropPoint | undefined>(undefined);
  const [originPadObject, setOriginPadObject] = useState(order.originLandingPad);
  const [shouldShowRecentFlightPathData, setShouldShowRecentFlightPathData] = useState<boolean>(false);
  
  const pads = useSelector(selectActivePads);
  const inactivePads = useSelector(selectInactivePads);
  const obstacles = useSelector(selectObstacles);
  const orders = useSelector(selectFilteredOrders);
  const selectedCellId = useSelector(selectSelectedCellId);
  
  const landingZones = useSelector(selectLandingZones);
  const stores = useSelector(selectPointOfSales);
  

  const [eircodeCoords, setEircodeCoords] = useState([0, 0]);
  const store = stores?.find((store) => { return store.fdStoreId.toString() === order.externalProviderId} );

  const landingZoneForStore = landingZones.find(lz => { return store?.landingZoneId === lz?.id });

  const lzCoords: any = [landingZoneForStore?.centreLatitude, landingZoneForStore?.centreLongitude];

  const intialCoords: [number, number] = lzCoords ?? balbrigganCoords;

  useEffect(() => {
    setOrderToUse(order);
    if (orderToUse.mission && orderToUse.mission.geoJson) {
      initializeRouteFromMission(orderToUse);
    }
  }, [order.mission?.geoJson]);

  useEffect(() => {
    setEircodeCoords(order?.dropLatlng?.split(',') ?? [0, 0]);
  }, [order?.dropLatLng]);

  useEffect(() => {
    dispatch(getLandingPads());

    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    dispatch(getObstacles(selectedCellId));
    dispatch(getLandingZonesInCell(selectedCellId));
  }, [selectedCellId]);

  useEffect(() => {
    updateOrder();
  }, [orderToUse.id]);

  useEffect(() => {
    const updatedOrder = orders.find(order => order.id === orderToUse.id);
    if ((updatedOrder as any).missionStatus !== orderToUse?.mission?.status) {
      getLatestOrderInfo().then(newInfo => {

        if (isMounted.current) {
          setOrderToUse(newInfo);
        }
      });
    }
    return () => {};
  }, [orders]);

  const selectArea = e => {

    const bounds: LatLngBounds = (e as any).bounds;

    const containedCoords = routeCoordsRef.current.filter(routePoint => {
      return bounds.contains(routePoint.coordinates);
    });
    updateSelectedRouteCoords(containedCoords);
  };

  useEffect(() => {
    if (mapRef.current) {
      (mapRef.current as any).selectArea.enable();
      mapRef.current.attributionControl.remove(); // removes the attribution section in bottom right corner of map

      // Allow map clicking for all cells
      mapRef.current.on('click', addMarker);
      mapRef.current.on('areaselected', selectArea);
    }
    return () => {
      if (mapRef.current) {
        mapRef.current.off('click', addMarker);
        mapRef.current.off('areaselected', selectArea);
      }
    };
  }, [mapRef.current, orderToUse?.cellId]); // Add orderToUse.cellId as dependency  // TODO: Remove this dependency

  // Removed unused effect generating routeJSON

  useEffect(() => {
    if (suggestedRouteCoords && pads && selectedOriginPadId) {
      const activelandingPadCoords = pads.find(
        pad => pad.id === selectedOriginPadId
      );
      const inactivelandingPadCoords = inactivePads.find(
        pad => pad.id === selectedOriginPadId
      );
      const newRouteCoords: [number, number][] = suggestedRouteCoords;
      if (activelandingPadCoords !== undefined) {
        newRouteCoords[0] = [
          activelandingPadCoords.latitude,
          activelandingPadCoords.longitude
        ];
      } else if (inactivelandingPadCoords !== undefined) {
        newRouteCoords[0] = [
          inactivelandingPadCoords.latitude,
          inactivelandingPadCoords.longitude
        ];
      }

      if (isMounted.current) {
        setSuggestedRouteCoords(newRouteCoords);
      }
    }
  }, [selectedOriginPadId, pads]);

  

  useEffect(() => {
    if (
      orderToUse.mission &&
      orderToUse.mission.geoJson &&
      missionIdRef.current !== orderToUse.mission.id
    ) {
      missionIdRef.current = orderToUse.mission.id;
    }
  }, [orderToUse.mission]);

  const onKeyUp = e => {
    if (e.code === 'Backspace') {
      deleteMarkers();
    }
  };

  // Updates both state and ref for selected route coordinates
  const updateSelectedRouteCoords = (newCoords: any[]) => {
    if (!isMounted.current) return;
    selectedCoordsRef.current = newCoords;
    setSelectedCoords(newCoords);
  };

  const updateOrder = async () => {

    try {
      const updatedOrder = await getLatestOrderInfo();
      dispatch(setRouteConfirmationOrder(updatedOrder));
    } catch (error) {
      logToDatadog('updateOrder_failed_in_route_confirmation', { error }, 'error')
    }
  };

  const getLatestOrderInfo = async () => {
    return await orderfulApi.getOrderById(orderToUse.id);
  };

  const closeScreen = () => {
    if (isMounted.current) {

      //Timeout needed 

      /**
       * Explanation of why we are checking if the component is mounted anywhere we set state and using a timeout before calling handleClose
       * 
       * fetchSuggestedRoute starts
       * If it fails and calls closeScreen
       * The Parent components (OrderHub) state updates immediately from handleClose
       * These state changes trigger re-renders
       * During these re-renders, the component is still mounted
       * The useEffect watching orderToUse.eircode fires again because the component is still mounted during state transitions
       * This starts another fetchSuggestedRoute
       * Repeat
       */
      setTimeout(() => {
        handleClose();
      }, 2500);
    }
  }

  

  const fetchSuggestedRoute = eircode => {
  
    if (!eircode) {

      notify({
        variant: 'error',
        message: 'No eircode found for order, closing route confirmation'
      });

      closeScreen();

      return;
    }

    orderfulApi.getPlaceContextByEircode(eircode.trim().toUpperCase())
      .then(res => {

        if (!isMounted.current) return;

        try {
          setAddressInfo(res);
          
          if (res.dropPoints?.data) {
            let featureCollectionWithReversedCoords = reverseRouteCoords(
              res.dropPoints?.data  
            );
            setSuggestedRouteCoords(featureCollectionWithReversedCoords);
          }
        } catch (error) {
          logToDatadog("fetchSuggestedRoute_inner_failed", { error }, 'error')
          notify({
            variant: 'error',
            message: 'Something went wrong when retrieving the customers address data, closing route confirmation'
          });
          closeScreen();
        }
      })
      .catch(error => {
        logToDatadog("fetchSuggestedRoute_failed", { error }, 'error')
        notify({
          variant: 'error',
          message: 'Could not retrieve customers drop location, closing route confirmation'
        });
        closeScreen();
      });
  };

  useEffect(() => {
    if (order.eircode !== orderToUse.eircode || !addressInfo || !eircodeCoords) {
      fetchSuggestedRoute(orderToUse.eircode);
    }
  }, [orderToUse?.eircode]);


  useEffect(() => {
    window.addEventListener('keyup', onKeyUp);
    initializeRouteFromMission(orderToUse);

    if (orderToUse?.mission?.landingPad?.name && isMounted.current) {
      setSelectedOriginPadId(orderToUse.mission.landingPad.id);
    }
    const getAirspaceInterval = setInterval(() => {
      fetchAirspace();
    }, 5000);

    return () => {
      window.removeEventListener('keyup', onKeyUp);
      clearInterval(getAirspaceInterval);
    };
  }, [orderToUse?.id, orderToUse?.mission]);

  // Set view bounds of the map when route coords are received
  const setMapBounds = routeCoords => {
    if (!isMounted.current || !routeCoords || !routeCoords.length) { return }
    console.log('setMapBounds', routeCoords);
    const bounds = latLngBounds([]);

    routeCoords.forEach(coord => {
      bounds.extend(coord?.coordinates ?? coord);
    });

    setOuterMapBounds(bounds as any);
  
    if (mapRef.current) {
      mapRef.current.fitBounds(bounds);
    }
  };

  const parseFlightRoutes = missions => {
    let hexMissions = {};
    Object.keys(missions).forEach(missionId => {
      const h3Hexes = missions[missionId].map(decimal => {
        return decToHex(decimal, { prefix: false });
      });
      hexMissions[missionId] = h3Hexes;
    });
    return hexMissions;
  };

  const fetchAirspace = async () => {

    if (!isMounted.current) { return }

    setMissionRoutes({} as any);
    setMissionRoutesLen((missionRoutesLen + 1) % 10);
    let lat = 53.269837;
    let lng = -8.931032;
    if (selectedCellId === 8) {
      lat = 33.09246542236036;
      lng = -97.2481172359254;
    }

    axios
      .get(
        `${process.env.REACT_APP_MANNA_CORE_API_HOST}/airspace/view?latitude=${lat}&longitude=${lng}`,
        await getOptions()
      )
      .then(res => {
        if (!isMounted.current) { return }
        const missions: any = parseFlightRoutes(res.data);
        setMissionRoutes(missions);
        setMissionRoutesLen((missionRoutesLen + 1) % 10);
      })
      .catch(err => {
        console.log('err: ', err);
      });
  };

  const generateAbitraryLineStringProperties = routeCoords => {
    const properties = {};
    for (var i = 0; i < routeCoords.length; i++) {
      let type = routeCoords[i].type;
      properties[i] = `index=${i},type=${type},relativeAltitude=66,speed=16,`;
    }
    return properties;
  };

  const reverseRouteCoords = routeCoords => {
    if (routeCoords[0]?.latitude && routeCoords[0]?.longitude) {
      return routeCoords?.map(point => [point.longitude, point.latitude])
    } else {
      return [];
    }
  };

  const getOptions = async () => {
    return {
      headers: {
        'x-api-key': 'kyGhOImQeI5mDYnJ9wKwi97XxtNde2cs7shMUGIT',
        Authorization: `Bearer ${await getLatestJwtToken()}`
      }
    };
  };

  /** ---------- Updating our Route Coords happens below START ---------- */
  // Helper function to check if a route should be symmetrical
  const shouldRouteBeSymmetrical = (order: any): boolean => {
    // Disable asymmetric route editing on Espoo and Espoo Test Site
    return [12, 13].includes(order.cellId);
  };

  // Helper function to clean routes for symmetrical routes (routes that use the same waypoints for
  // inbound and outbound legs)
  const outboundLeg = (routeCoords: RoutePoint[], order: any): RoutePoint[] => {
    const dropPointIndex = routeCoords.findIndex(coord => coord.type === RoutePointType.CUSTOMER_DROP_LOCATION);
    if (dropPointIndex === -1) {
      return routeCoords;
    }

    // For symmetrical routes, only return the outbound leg (up to and including drop point)
    const outboundRoute = routeCoords.slice(0, dropPointIndex + 1);
    
    // Update indices to maintain proper sequence
    return outboundRoute.map((point, idx) => ({
      ...point,
      index: idx
    }));
  };

  // Source of truth for updating route - updates both state and ref for route coordinates
  // Automatically cleans routes for symmetrical cells to maintain consistency
  const updateRouteCoordinates = (newCoords: RoutePoint[]) => {
    if (!isMounted.current) return;
    
    // Always clean routes for symmetrical cells to ensure consistency
    const cleanedCoords = shouldRouteBeSymmetrical(orderToUse) 
      ? outboundLeg(newCoords, orderToUse)
      : newCoords;
    
    routeCoordsRef.current = cleanedCoords;
    setRouteCoords(cleanedCoords);
  };

  // Removes any coordinates from the route that match coordinates in the current selection aka any in selectedCoordsRef
  const deleteMarkers = () => {
    if (!isMounted.current) return;

    updateRouteCoordinates(
      routeCoordsRef.current.filter(
        routePoint =>
          !selectedCoordsRef.current.find(
            selectedPoint =>
              routePoint.coordinates[0] === selectedPoint.coordinates[0] && 
              routePoint.coordinates[1] === selectedPoint.coordinates[1]
          )
      )
    );
  };


  // Creates/recreates the actual route by extracting first leg (base -> customer) from the mission's route data
  // Called on:
  // - Initial component load with mission data
  // - After successful route updates/reservations
  // - When receiving updated mission data
  // Updates map state with new route coordinates, geo tunnel, properties, bounds and airspace data
  const initializeRouteFromMission = (order: any) => {
    if (!isMounted.current) { return }

    if (order.mission && order.mission.geoJson) {
      const routeCoords = order.mission.geoJson.features.map(feature => {
        return {
          coordinates: [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
          type: feature.properties.type,
          index: Number(feature.properties.index)
        };
      });
      updateRouteCoordinates(routeCoords);
      setGeoTunnel(order.mission.geoJsonGeotunnel);
      setMapBounds(routeCoords);
    }
    else
    {
      var tempCoords = order.originLandingPadId && updateOriginPad(pads.find(pad => pad.id === order.originLandingPadId));
      order.destinationLandingPadId && updateDestinationPad(pads.find(pad => pad.id === order.destinationLandingPadId), tempCoords);

    }

    fetchAirspace();
  };




  const updateOriginPad = (originPad: LandingPad, temporaryRouteCoords: RoutePoint[] = null) => {
    const newRouteCoords = temporaryRouteCoords ? [...temporaryRouteCoords] : [...routeCoords];
    newRouteCoords[0] = {
      coordinates: [originPad.latitude, originPad.longitude],
      type: RoutePointType.START_POINT_BASE,
      index: 0
    };
    setOriginPadObject(originPad);
    updateRouteCoordinates(newRouteCoords);
    setMapBounds(newRouteCoords);
    setSelectedOriginPadId(originPad.id);
    return newRouteCoords;
  }

  const updateDestinationPad = (destinationPad: LandingPad, temporaryRouteCoords: RoutePoint[] = null) => {
    const newRouteCoords = temporaryRouteCoords ? [...temporaryRouteCoords] : [...routeCoords];
    var coordToAdd = {
      coordinates: [destinationPad.latitude, destinationPad.longitude],
      type: RoutePointType.END_POINT_BASE,
    } as RoutePoint;

    if (newRouteCoords.length > 1 && newRouteCoords[newRouteCoords.length - 1].type === RoutePointType.END_POINT_BASE) {
      newRouteCoords[newRouteCoords.length - 1] = { ...coordToAdd, index: newRouteCoords.length - 1 };
    } else {
      newRouteCoords.push({ ...coordToAdd, index: newRouteCoords.length });
    }

    updateRouteCoordinates(newRouteCoords);
    setMapBounds(newRouteCoords);
    setSelectedDestinationPadId(destinationPad.id);
    return newRouteCoords;
  }

  // Updates coordinates at markerIndex when a marker is dragged to a new position
  // Creates new route coords array and sets the dragged marker's new position, 
  // then updates altitude graph to reflect new route
  const updateMarker = React.useCallback((evt: DragEndEvent, markerIndex: number) => {
    if (!isMounted.current) { return }
  
    const latLng = evt.target.getLatLng();
  
    const newRouteCoords: RoutePoint[] = [...routeCoords];
    newRouteCoords[markerIndex] = {
      ...newRouteCoords[markerIndex],
      coordinates: [latLng.lat, latLng.lng] as [number, number]
    };
    
    // No need to update indices since we're just changing coordinates
    // Order/length hasn't changed
    
    updateRouteCoordinates(newRouteCoords);
    setHasUpdatedRoute(true);
  }, [routeCoords, updateRouteCoordinates]);

  // Removes a point from the route at markerIndex when marker is deleted
  // Creates new route coords array and removes the marker at specified index
  const removeMarker = React.useCallback((evt: LeafletMouseEvent, markerIndex: number) => {
    if (!isMounted.current) { return }

    if (routeCoords.length - 1 === markerIndex && routeCoords.length > 2) {

      const indexBeforeMarker = markerIndex - 1;
      const routeCoordBeforeRemovedCoord = routeCoords.find(coord => {return Number(coord.index) === indexBeforeMarker});

      const lat = routeCoordBeforeRemovedCoord.coordinates[0];
      const lng = routeCoordBeforeRemovedCoord.coordinates[1];
      createProposedNewDropPoint(lat, lng, false, false);
    }

    const newRouteCoords: RoutePoint[] = [...routeCoords];
    newRouteCoords.splice(markerIndex, 1);
    
    // Update indices after removal to maintain sequence
    newRouteCoords.forEach((point, idx) => {
      point.index = idx;
    });
    
    updateRouteCoordinates(newRouteCoords);
    setHasUpdatedRoute(true);
  }, [routeCoords, updateRouteCoordinates]);

  // Adds a new point to the route when map is clicked
  // If route has 2+ points: finds closest line segment and inserts point after it
  // If route has 0-1 points: adds point to end of route
  // Creates new route coords array and updates with new point
  function addMarker(evt) {
    if (!isMounted.current) { return }

    const coordsToAdd: RoutePoint = {
      coordinates: [evt.latlng.lat, evt.latlng.lng],
      type: RoutePointType.WAYPOINT,
      index: routeCoordsRef.current.length
    };

    const newRouteCoords = [...routeCoordsRef.current];
    
    if (routeCoordsRef.current.length > 1) {

      const distanceFromSegments = newRouteCoords
        .map((point, i, arr) => {
          if (i === 0) return null;
          const dist = distToSegment(
            coordsToAdd.coordinates, 
            arr[i - 1].coordinates, 
            point.coordinates
          );
          return dist;
        })
        .filter(Boolean);

      const closestSegment = Math.min(...distanceFromSegments);
      const index = distanceFromSegments.indexOf(closestSegment);
      
      newRouteCoords.splice(index + 1, 0, coordsToAdd);
      // Update indices after insertion
      newRouteCoords.forEach((point, idx) => {
        point.index = idx;
      });
    } else {
      newRouteCoords.push(coordsToAdd);
    }
    updateRouteCoordinates(newRouteCoords);
    setHasUpdatedRoute(true);
  }

  // Removes all points from route except takeoff and drop points
  // Only executes if route has at least 2 points
  // Creates new route coords array with just the first (takeoff) and last (drop location) coordinates
  const clearWaypoints = () => {
    if (!isMounted.current) { return }

    if (routeCoords.length < 2) {
      return;
    }
    const firstRouteCoord = routeCoords[0]; // start point
    const dropPoint = routeCoords.find(point => point.type === RoutePointType.CUSTOMER_DROP_LOCATION);
    const lastRouteCoord = routeCoords[routeCoords.length - 1]; // end point

    let newCoords = [
      { ...firstRouteCoord, index: 0 },
      { ...dropPoint, index: 1 }
    ];

    if (!shouldRouteBeSymmetrical(orderToUse)) {
      newCoords.push({ ...lastRouteCoord, index: 2 });
    }
    
    updateRouteCoordinates(newCoords);
  };

  // Updates the drop point (last coordinate) of the route with new lat/long
  // If route exists (2+ points): updates the last coordinate
  // If route is empty/has 1 point: adds the new coordinate to the end
  // Creates new route coords array and updates with new landing point
  const updateDropPointOnRoute = ({
    latitude,
    longitude
  }: {
    latitude: number;
    longitude: number;
  }): void => {
    if (!isMounted.current) { return }

    const coordsToAdd: RoutePoint = {
      coordinates: [latitude, longitude],
      type: RoutePointType.CUSTOMER_DROP_LOCATION,
      index: 0
    };

    let newRouteCoords: RoutePoint[] = [...routeCoordsRef.current];
    const existingDropPoints = newRouteCoords.filter(point => point.type === RoutePointType.CUSTOMER_DROP_LOCATION);
    
    if(existingDropPoints.length > 0) {
      newRouteCoords[existingDropPoints[0].index] = { ...coordsToAdd, index: existingDropPoints[0].index };
    } else if (newRouteCoords.length > 1 && newRouteCoords[newRouteCoords.length - 1].type === RoutePointType.END_POINT_BASE) {
      // For asymmetrical routes, insert the new drop point one before the end (before the END_POINT_BASE)
      // This preserves the return-to-base endpoint while updating the customer drop location
      if (!shouldRouteBeSymmetrical(orderToUse)) {
        newRouteCoords.splice(newRouteCoords.length - 1, 0, { ...coordsToAdd, index: newRouteCoords.length - 1 });
      } else {
        // For symmetrical routes, replace the end point with the drop point
        newRouteCoords[newRouteCoords.length - 1] = { ...coordsToAdd, index: newRouteCoords.length - 1 };
      }
      // Update indices to maintain sequential ordering
      newRouteCoords.forEach((point, idx) => {
        point.index = idx;
      });
    } else {
      newRouteCoords.push({ ...coordsToAdd, index: newRouteCoords.length });
    }
    updateRouteCoordinates(newRouteCoords);
  };

  /** ---------- Changes to our route coords happens above END ---------- */

  const deleteMissionAirspace = () => {
    const yesDelete = window.confirm(
      'Are you sure you want to delete the current mission route'
    );
    if (yesDelete) {
      if (orderToUse.missionId) {
        API.post(
          'api',
          `/mission/route/remove/?orderId=${orderToUse.id}&missionId=${orderToUse.missionId}&flightapi=1.6.3`,
          {}
        )
          .then(res => {
            notify({ variant: 'success', message: 'Deleted mission airspace' });
            fetchAirspace();
            updateOrder();
          })
          .catch(err => {
            notify({
              variant: 'error',
              message: 'Failed to delete mission airspace'
            });
          });
      } else {
        alert('There is no mission id for this order');
      }
    }
  };

  const createRouteFeatureCollectionFromCoordsAndProperties = (
    routeCoords,
    properties
  ) => {
    let props;
    let reversedRouteCoords = routeCoords.map(point => {
      return [point.coordinates[1], point.coordinates[0]];
    });
    if (properties) {
      props = properties;
    } else {
      props = generateAbitraryLineStringProperties(routeCoords);
    }
    return createFeatureCollectionWithCoords(reversedRouteCoords, props);
  };

  const updateRoute = () => {
    if (!isMounted.current) { return }

    setUpdating(true);

    let newRouteCoords = [...routeCoords];
    if (shouldRouteBeSymmetrical(orderToUse)) {
      // Get route up to drop point
      const dropPointIndex = routeCoords.findIndex(coord => coord.type === RoutePointType.CUSTOMER_DROP_LOCATION);
      if (dropPointIndex !== -1) {
        // Take route up to drop point
        const routeToDropPoint = routeCoords.slice(0, dropPointIndex + 1);
        // Create reversed route from drop point back to start, excluding the drop point itself
        const reversedRoute = [...routeToDropPoint.slice(0, -1)].reverse();
        // Combine routes to create full route
        newRouteCoords = [...routeToDropPoint, ...reversedRoute];
      }
    }
    
    const routeFeatureCollection = createRouteFeatureCollectionFromCoordsAndProperties(
      newRouteCoords,
      null
    );
    API.post(
      'api',
      `/mission/route/update/?orderId=${orderToUse.id}&missionId=${orderToUse.missionId}&flightapi=1.6.3`,
      {
        body: routeFeatureCollection
      }
    )
      .then(resOrder => {
        // Set response as the selected order
        notify({ variant: 'success', message: 'Update route' });
        setUpdating(false);
        initializeRouteFromMission(resOrder);
        dispatch(finaliseRouteThunk(orderToUse.id));
        dispatch(upsertOrderCardById(orderToUse.id));
        updateOrder();
      })
      .catch(err => {
        setUpdating(false);
        notify({ variant: 'error', message: 'Failed to update route: ' + (err.response.data?.errorDetail || 'Unknown error') });
      });
  };

  const reserveRoute = () => {
    if (!isMounted.current) { return }

    setReserving(true);
    API.post(
      'api',
      `/mission/route/reserve/?orderId=${orderToUse.id}&missionId=${orderToUse.missionId}&flightapi=1.6.3`,
      {}
    )
      .then(resOrder => {
        notify({ variant: 'success', message: 'Route reserved' });
        setReserving(false);
        initializeRouteFromMission(resOrder);
        dispatch(upsertOrderCardById(orderToUse.id));
        updateOrder();
      })
      .catch(err => {
        notify({ variant: 'error', message: 'Failed to reserve route: ' + (err.response.data?.errorDetail || 'Unknown error') });
        setReserving(false);
      });
  };

  const createProposedNewDropPoint = React.useCallback((lat: number, lng: number, isLowRisk: boolean, isEvaluated: boolean) => {
    if (!isMounted.current) { return }

    // Prevent creating new drop points for cell
    if (isDropPointCreationDisabled(orderToUse?.cellId)) {
      notify({
        variant: 'warning',
        message: getDropPointRestrictionMessage(orderToUse?.cellId)
      });
      return;
    }

    logToDatadog('alternate drop point selected', {
      from: proposedNewDropPoint,
      to: { lat, lng }
    });
    setProposedNewDropPoint(prev => ({
      ...prev,
      isLowRisk,
      isEvaluated,
      latitude: lat,
      longitude: lng,
      id: null
    }));
    updateDropPointOnRoute({ latitude: lat, longitude: lng });
    setHasUpdatedRoute(true);
  }, [proposedNewDropPoint, updateDropPointOnRoute, orderToUse?.cellId, notify]);

  const routeHasLessThan2Points = (): boolean => {
    return routeCoords?.length < 2;
  };

  const isDropPointRequiredButMissing = (): boolean => {
    // For VERIFIED only cells, ensure a drop point is selected
    if (isVerifiedRiskOnlyCell(orderToUse?.cellId)) {
      return !proposedNewDropPoint;
    }
    return false;
  };

  const hasInvalidDropPoints = (): boolean => {
    if (!proposedNewDropPoint) {
      return false;
    }
    if ('isLowRisk' in proposedNewDropPoint && proposedNewDropPoint.isLowRisk !== undefined) {
      return proposedNewDropPoint.isLowRisk;
    }
    return false;
  };

  // If MISSION is in HOLD or ORDER is READY (or further status) hide buttons
  const showRouteActionButtons =
    orderToUse.mission?.status === 'HOLD' ||
    PAST_READY_STATUS_ARRAY.includes(orderToUse.status);

  const hideReserveRoute =
    orderToUse.mission?.status === 'HOLD' ||
    orderToUse.mission?.status === 'COMPLETED' ||
    orderToUse.mission?.status === 'IN_PROGRESS';

  const memoizedMissionRoutes = useMemo(() => missionRoutes, [JSON.stringify(missionRoutes)]);

  // Memoized route distance calculation for performance
  const routeDistance = useMemo(() => {
    if (!routeCoords || routeCoords.length < 2) {
      return 0;
    }

    let totalDistance = 0;
    for (let i = 0; i < routeCoords.length - 1; i++) {
      const [lat1, lng1] = routeCoords[i].coordinates;
      const [lat2, lng2] = routeCoords[i + 1].coordinates;
      const segmentDistance = getDistanceBetweenPoints(lat1, lng1, lat2, lng2);
      totalDistance += segmentDistance;
    }

    // Convert from meters to kilometers and always round up to 1 decimal place for safety
    return Math.ceil((totalDistance / 1000) * 10) / 10;
  }, [routeCoords]);

  return (
    <Modal
      open
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description">
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '94%',
          height: '88vh',
          maxWidth: 'none',
          borderRadius: 24,
          backgroundColor: 'white'
        }}>
        <Grid container style={{ height: '100%' }}>
          <Grid item xs={6} style={{ height: '100%' }}>
            <RouteConfirmationMap
              landingPads={pads}
              selectedOriginPad={originPadObject}
              selectedDestinationPad={originPadObject}
              intialCoords={intialCoords}
              outerMapBounds={outerMapBounds}
              mapRef={mapRef}
              obstacles={obstacles}
              missionRoutes={memoizedMissionRoutes}
              routeCoords={routeCoords}
              order={orderToUse}
              selectedCoords={selectedCoords}
              missionRoutesLen={missionRoutesLen}
              removeMarker={removeMarker}
              updateMarker={updateMarker}
              proposedNewDropPoint={proposedNewDropPoint}
              eircodeCoords={eircodeCoords}
              geoTunnel={geoTunnel}
              geofences={geofences}
              shouldShowHeatmap={shouldShowRecentFlightPathData}
              createProposedNewDropPoint={createProposedNewDropPoint}
              markerArrowsEnabled={!shouldRouteBeSymmetrical(orderToUse)}
              isDragDisabled
            />
          </Grid>
          <Grid item xs={6} style={{ position: 'relative', height: '100%' }}>
            <Grid
              container
              flexBasis="space-between"
              style={{
                width: '100%',
                padding: 15,
                borderBottom: '1px solid #D9DBE9'
              }}>
              <Grid item>
                <h3
                  className={'text-lg font-semibold text-gray-800'}
                  style={{ marginTop: 3, marginBottom: 6 }}>
                  Order Route
                </h3>
                <Switch.Group as="div" className="flex items-center">
                  <Switch
                    checked={shouldShowRecentFlightPathData}
                    onChange={(isChecked) => {
                      if (isMounted.current) {
                        setShouldShowRecentFlightPathData(isChecked)
                      }
                    }}
                    className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 ${shouldShowRecentFlightPathData ? 'bg-blue-600' : 'bg-gray-200'}`}
                  >
                    <span
                      aria-hidden="true"
                      className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${shouldShowRecentFlightPathData ? 'translate-x-5' : 'translate-x-0'}`}
                    />
                  </Switch>
                  <Switch.Label as="span" className="ml-3 text-sm">
                    <span className="font-medium text-gray-900">Heatmap</span>
                  </Switch.Label>
                </Switch.Group>


                <Grid container spacing={1}>
                  <Grid item>
                    <Typography variant="body2">
                      Mission Status: {orderToUse.mission?.status} |
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2">
                      Eircode: {orderToUse.eircode} |
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2">
                      Route Distance: {renderOrderKm(routeDistance)} |
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" style={{ marginBottom: 10 }}>
                      Order Status: {orderStatuses[orderToUse.status].name}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item flexGrow={1}>
                <Button style={{ float: 'right' }} onClick={handleClose}>
                  <CloseIcon></CloseIcon>
                </Button>
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="center">
              <Grid item xs={3} style={{ width: 100 }}>
                <Typography variant="body2">
                  {pads.find(p => p.id == selectedOriginPadId)?.name || 'Not Set'}
                </Typography>
              </Grid>
              <Grid item xs={1}>➡️</Grid>
              <Grid item xs={3}>{orderToUse.eircode}</Grid>
              <Grid item xs={1}>➡️</Grid>
              <Grid item xs={3} style={{ width: 100 }}>
                <Typography variant="body2">
                  {pads.find(p => p.id == selectedDestinationPadId)?.name || 'Not Set'}
                </Typography>
              </Grid>
            </Grid>
            <div style={{ paddingLeft: 15, paddingTop: 12 }}>
              <Typography variant="h5" style={{ color: '#6E7191' }}>
                Drop spots
              </Typography>
              {isVerifiedRiskOnlyCell(orderToUse?.cellId) && !proposedNewDropPoint && (
                <Typography variant="body2" style={{ color: '#9C27B0', marginTop: 4, fontStyle: 'italic', fontWeight: 'bold' }}>
                  🟣 {getCellNameForRestrictions(orderToUse?.cellId)}: Please select a VERIFIED drop point from the list below to continue.
                </Typography>
              )}
              {isDropPointCreationDisabled(orderToUse?.cellId) && (
                <Typography variant="body2" style={{ color: '#ED0505', marginTop: 4, fontStyle: 'italic' }}>
                  ⚠️ {getCellNameForRestrictions(orderToUse?.cellId)}: Only predefined drop points can be selected. Drop point editing is disabled.
                </Typography>
              )}
            </div>
            <Grid
              container
              style={{
                width: '100%',
                paddingLeft: 12,
                paddingRight: 12,
                paddingTop: 6,
                maxHeight: 300,
                overflowY: 'auto',
                overflowX: 'hidden',
              }}>
              {addressInfo?.dropPoints
                ?.data?.filter(dph => dph.id === addressInfo?.place?.preferredDropPointId)
                ?.map(dph => {
                  let distanceFromDrop = 0;
                  if (routeCoords?.length > 0) {
                    var dropCoord = routeCoords.find(rc => rc.type === RoutePointType.CUSTOMER_DROP_LOCATION);
                    if (dropCoord) {
                      distanceFromDrop = getDistanceBetweenPoints(
                        dropCoord.coordinates[0],
                        dropCoord.coordinates[1],
                        dph.latitude,
                        dph.longitude
                      );
                    }
                  }


                    return (
                      <div style={{ width: '100%' }}>
                      
                      <DropPointRow
                        key={dph.id}
                        dropPoint={dph}
                        placeContext={addressInfo}
                        isSelected
                        onSelect={() => {}}
                        riskAssessment={null}
                        isLoadingRiskAssessment={false}
                        selectedDropPointId={addressInfo?.place?.preferredDropPointId}
                        isNarrow={false}
                        showManagementFeatures={false}
                        onDropPointDelete={() => {}}
                        onSetPreferred={() => {}}
                        showConfirmDelete={null}
                        onShowConfirmDelete={() => {}}
                        showDeletedPoints={false}
                    /></div>
                    )
                })}
              {!addressInfo?.dropPoints?.data?.some(d => d.id === addressInfo?.place?.preferredDropPointId) ? (
                <Typography variant="body1">
                  No preferred drop location for this address
                </Typography>
              ) : (
                <></>
              )}
            </Grid>
            {showRouteActionButtons && (
              <Grid
                container
                style={{
                  width: '100%',
                  paddingBottom: 6,
                  marginTop: 10,
                  paddingLeft: 15,
                  boxShadow: '0px 8px 16px rgba(17, 17, 17, 0.04)'
                }}>
                <Grid item>
                  <Button
                    style={{ color: '#ED0505' }}
                    variant="outlined"
                    onClick={deleteMissionAirspace}>
                    Delete Mission Airspace
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    disabled={orderToUse.mission?.status === 'HOLD'}
                    variant="outlined"
                    style={{
                      marginLeft: 10,
                      marginRight: 15,
                      color:
                        orderToUse?.mission?.status === 'HOLD'
                          ? 'rgba(0, 0, 0, 0.26)'
                          : '#14142B',
                      backgroundColor:
                        orderToUse?.mission?.status === 'HOLD'
                          ? 'rgba(0, 0, 0, 0.12)'
                          : 'white'
                    }}
                    onClick={() => {
                      clearWaypoints();
                      logToDatadog('waypoints cleared', {
                        dropPoint: proposedNewDropPoint
                      });
                    }}>
                    Clear waypoints
                  </Button>
                  {hasUpdatedRoute && (
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={updating || !hasInvalidDropPoints() || isDropPointRequiredButMissing()}
                      endIcon={updating ? <CircularProgress size={12} /> : null}
                      style={{ marginLeft: 10, marginRight: 10 }}
                      onClick={updateRoute}>
                      Update &amp; Reserve Route
                    </Button>
                  )}
                  {!hasUpdatedRoute && !hideReserveRoute && (
                    <Button
                      color="primary"
                      variant="contained"
                      disabled={reserving || routeHasLessThan2Points() || isDropPointRequiredButMissing()}
                      endIcon={
                        reserving ? <CircularProgress size={12} /> : null
                      }
                      onClick={reserveRoute}>
                      Reserve Route
                    </Button>
                  )}

                </Grid>
              </Grid>
            )}
            <div
              style={{
                width: '100%'
              }}
              >
                <RouteConfirmationGraph height={CODE_DISPLAY_HEIGHT * 0.33} geoJson={orderToUse?.mission?.geoJson} />
            </div>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    notify: notification => dispatch(newNotification(notification)),
    setSelectedOrder: orderToUse => {
      dispatch({
        type: ORDER_RECEIVED,
        payload: orderToUse
      });
    },
    validateDropLocation: (lat, lng) => dispatch(validateDropLocation(lat, lng)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteConfirmation);
